import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    transition: '.5s ease-in-out',
    gridGap: '1rem',
    maxWidth: '100%',
    '& .MuiAccordionDetails-root': {
      paddingTop: '0',
      justifyContent: 'center',
    },
    marginBottom: '15px',
    '& span': {
      paddingLeft: 0,
    },
    // legend spacing
    '& > div:last-child': {
      maxWidth: '31vw',
    },
  },
});

export default useStyles;
